document.addEventListener('DOMContentLoaded', function () {
    let button = document.querySelectorAll('[bss-b2b-variant-click]')
    if (button.length) {
        button.forEach(element => {
            element.addEventListener('click', ()=>{
                  const urlParams = new URLSearchParams(window.location.search);
                   const variantId = urlParams.get('variant');
                   let price = document.querySelector('[bss-b2b-main-product-form] [bss-b2b-variant-id]')
                   price.setAttribute('bss-b2b-variant-id', variantId)
                const productForm = document.querySelector("[bss-b2b-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                   
            })
        });
    }
});